import { useMemo } from 'react';

import { Article, Price } from '../../../../models/Article';
import { ProductMetaData } from '../../../../models/Product';

import sortBy from 'lodash/sortBy';
import { UNLIMITED_USAGE_LIMIT } from '../../../store/constants';

interface UseAvailablePrices {
    readonly availablePrices: ReadonlyArray<Price>;
}

export function useAvailablePrices(product: ProductMetaData & Article): UseAvailablePrices {
    const availablePrices = useMemo(
        () =>
            product.availablePrices
                ? sortBy(product.availablePrices, ['lendingModel', sortByUsageLimit, 'termLimit'])
                : [],
        [product.availablePrices]
    );

    return {
        availablePrices
    };
}

function sortByUsageLimit(price: Price): number | undefined {
    return price.usageLimit === UNLIMITED_USAGE_LIMIT ? Number.MAX_SAFE_INTEGER : price.usageLimit;
}
